/**
 * @file: useWeixinCustomServiceChat.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCallback } from 'react';

export const useWeixinCustomServiceChat = () => {
  return useCallback(async () => {}, []);
};
